var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.icon && _vm.icon.url)?_c('img',{class:{avatar: true, roundicon: _vm.square},attrs:{"src":_vm.icon.url,"alt":""}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }